// extracted by mini-css-extract-plugin
export default {"layout":"settingsFormLayout_layout__3vb9b","block":"settingsFormLayout_block__hd5ew","info":"settingsFormLayout_info__3K2FY","input":"settingsFormLayout_input__1ymN7"};